var React = require('react');

function Profil (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"9","r":"5","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M20 21C20 15 15 14 12 14C9 14 4 15 4 21","stroke":"currentColor","strokeWidth":"2","key":1})]);
}

Profil.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Profil;

Profil.default = Profil;
